import { render, staticRenderFns } from "./DetailViewTableDetail.vue?vue&type=template&id=23835010"
import script from "./DetailViewTableDetail.vue?vue&type=script&lang=js"
export * from "./DetailViewTableDetail.vue?vue&type=script&lang=js"
import style0 from "./DetailViewTableDetail.vue?vue&type=style&index=0&id=23835010&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports